/**
 * Plane A Access Review feature key (Review Manager / Super Admin Read).
 * Matches BE InternalFeatureKeys.AccessReview / UM.AccessReview.Read.
 */
export const ACCESS_REVIEW_POLICIES = {
  READ: 'AccessReview'
} as const;

export type AccessReviewPermissionPolicy = (typeof ACCESS_REVIEW_POLICIES)[keyof typeof ACCESS_REVIEW_POLICIES];
